import React from 'react'
import './password.css'

export default function PasswordRequirement({ state, children }) {

    const icon = state === 'valid' ? 'check_circle' : 'remove_circle'

    return <div className={`passwordRequirement${state ? ` passwordRequirement--${state}` : ''}`}><i className='material-icons'>{ icon }</i> { children }</div>

}


// WEBPACK FOOTER //
// ./src/components/Password/index.js